<template>
  <!-- v-show="show" -->
  <div @touchmove.stop class="fill-after-sale-info">
    <close @close="close" show-home title="填写售后信息" />
    <div class="info-wrapper">
      <sku-details :sku="sku"></sku-details>
      <div class="product-num-handle">
        <div>申请售后数量:</div>
        <stepper
          :disable-input="true"
          :max="sku.invoice_number"
          :min="1"
          class="after-sale-stepper"
          input-width="38"
          v-model="switchingCounter.count"
        ></stepper>
      </div>
      <div class="after-why">
        <a @click="afterWhyCheck" class="after-why-desc" href="javascript:;">
          <div>申请售后原因</div>
          <div class="recose">
            <em>{{radioValue}}</em>
            <img src="../../assets/img/arrow-left.png" />
          </div>
        </a>
      </div>
      <div class="problem-desc">
        <h3>问题描述</h3>
        <textarea
          maxlength="140"
          placeholder="请描述申请售后服务的具体原因，包括文字和图片，图片请至少上传1张，最多可上传5张"
          v-model="userIntro"
        ></textarea>
        <div class="upload-img">
          <upload :max="uploadSet.max" :multiple="uploadSet.multiple" @change="previewFinished"></upload>
        </div>
      </div>
      <div class="contact-way">
        <h3>联系方式</h3>
        <div class="user-name">
          <input placeholder="填写联系人姓名" type="text" v-model="userName" />
        </div>
        <div class="user-phone">
          <input maxlength="11" placeholder="填写联系人电话" type="tel" v-model="userPhone" />
        </div>
      </div>
      <div class="user-address-details">
        <!-- <user-adderss :address="userAddress"></user-adderss> -->
      </div>
      <div class="submit-after-sale-btn">
        <button @click="submitInfo" class="submit-after-sale">提交售后</button>
      </div>
    </div>
    <div class="contact-service">
      <h3>联系客服</h3>
      <p>有问题请您拨打客服电话：400-6687017</p>
      <p>（服务时间：工作日 09:00 -18:00）</p>
    </div>
    <Popup
      :position="'bottom'"
      @touchmove.prevent
      class="return-reason-mask"
      v-model="popupVisible"
    >
      <div class="return-reason">
        <div class="title">
          <h2>申请原因</h2>
          <a @click="closePopup" class="close" href="javascript:;"></a>
        </div>
        <div class="return-reason-list" ref="reasonList">
          <div class="reason-list-wrapper">
            <radio-group v-model="radioValue">
              <radio
                :key="index"
                :name="reason"
                checked-color="#FF2851"
                class="radio-item"
                label-position="left"
                v-for="(reason, index) in reasons"
              >{{reason}}</radio>
            </radio-group>
          </div>
        </div>
        <button @click="closePopup" class="close-popup">确认</button>
      </div>
    </Popup>
    <dialogs
      :cancel-text="dialog.cancelText"
      @cancel-handler="cancelHandler"
      @confrim-handler="confrimHandler"
      v-model="dialog.show"
    >
      <p slot="msg">您确定要提交售后申请吗？</p>
    </dialogs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Close from '../Close'
import SkuDetails from './SkuDetails'
import { Popup, RadioGroup, Radio, Stepper } from 'vant'
import upload from '../Upload'
import Dialogs from '../Dialog'
let flag = false
export default {
  name: 'fillAfterSaleInfo',
  components: {
    Close,
    Popup,
    upload,
    Stepper,
    Dialogs,
    RadioGroup,
    Radio,
    SkuDetails
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    sku: {
      type: Object
    }
  },
  data () {
    return {
      switchingCounter: {
        count: 1,
        maxNum: 1
      },
      dialog: {
        show: false,
        cancelText: '再想想'
      },
      uploadSet: {
        max: 5,
        multiple: true
      },
      reasons: ['缺少件', '发错货', '质量问题', '商品损坏', '其他'],
      popupVisible: false,
      radioValue: '请选择原因',
      uploadList: [],
      userIntro: '',
      userPhone: '',
      userName: '',
      productDetails: {},
      userAddress: {}
    }
  },
  computed: {
    ...mapState('afterSale', ['productId'])
  },
  methods: {
    subtract ({ count }) {
      this.switchingCounter.count = count
    },
    add ({ count }) {
      // console.log(count)
      this.switchingCounter.count = count
    },
    closePopup () {
      this.popupVisible = false
    },
    close (e) {
      this.$emit('change', { close: true, status: false })
    },
    afterWhyCheck () {
      this.popupVisible = true
    },
    previewFinished (imgs) {
      this.uploadList = imgs
    },
    submitInfo () {
      if (this.radioValue === '请选择原因') {
        this.$toast('请选择退货原因')
        return false
      } else if (this.userIntro === '') {
        this.$toast('请输入退货描述')
        return false
      } else if (!this.uploadList.length) {
        this.$toast('请上传商品问题图片')
        return false
      } else if (this.userName === '') {
        this.$toast('请输入您的姓名')
        return false
      } else if (this.userPhone === '') {
        this.$toast('请输入您的手机号')
        return false
      } else if (!/^1[3,4,5,6,7,8,9]\d{9}/g.test(this.userPhone)) {
        this.$toast('请输入正确的手机号')
        return false
      }
      this.dialog.show = true
    },
    async confrimHandler () {
      if (flag) {
        return false
      }
      flag = true
      const status = await this.submitInfoHandler()
      // console.log(status)
      if (status) {
        this.dialog.show = false
        this.$emit('change', { close: true, status: true })
      }
      flag = false
    },
    cancelHandler () {
      this.dialog.show = false
    },
    async getProductDetails () {
      // this.$loading.open('正在加载...')
      const res = await this.$axios.get('?r=refund/refund-web/goods-detail', {
        params: {
          detail_id: this.productId - 0
        }
      })
      if (res.status === 200) {
        // this.$loading.close()
        const { code, data, msg } = res.data
        if (code === 0) {
          this.productDetails = data.goodsdetail
          this.userAddress = data.goodsdetail.receiver
          this.switchingCounter.maxNum = this.productDetails.express_number
        } else {
          this.$toast(msg)
        }
      }
    },
    async submitInfoHandler () {
      this.$toast.loading({
        duration: 30000,
        message: '正在上传,请稍后...'
      })
      const formData = new FormData()
      this.uploadList.forEach((value, key) => {
        formData.append('pic_list[]', value)
      })
      formData.append('trade_id', this.sku.trade_id)
      formData.append('child_trade_id', this.sku.child_trade_id)
      formData.append('sku_id', this.sku.sku_id)
      formData.append('count', this.switchingCounter.count)
      formData.append('reason', this.radioValue)
      formData.append('reason_desc', this.userIntro)
      formData.append('name', this.userName)
      formData.append('phone', this.userPhone)
      const res = await this.$axios({
        method: 'post',
        url: 'api/refund/apply',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
        // processData: false, // 不处理数据
        // contentType: false // 不设置内容类型
      })
      if (res.status === 200) {
        this.$toast.clear()
        const { msg, code } = res.data
        if (code === 0) {
          this.$toast('提交成功')
          return true
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less">
.after-sale-stepper {
  .van-stepper__minus,
  .van-stepper__plus {
    width: 0.54rem;
    height: 0.54rem;
    // border: 0.02rem solid #d5d5d5;
    .hairline-surround(@color: #d5d5d5, @radius: 0);
    color: #646464;
    background-color: transparent;
  }

  .van-stepper__minus--disabled,
  .van-stepper__plus--disabled {
    background-color: #f2f3f5;
    color: #c8c9cc;
  }
  .van-stepper__minus:active,
  .van-stepper__plus:active {
    background-color: transparent;
  }
  .van-stepper__input[disabled] {
    background-color: transparent;
  }
  // .van-stepper__minus--disabled,
  // .van-stepper__plus--disabled {
  //   // color: #d5d5d5;
  //    color: #646464;
  // }
  .van-stepper__input[disabled] {
    color: #484848;
    width: 0.75rem;
    height: 0.54rem;
    margin: 0;
    padding: 0;
    border-top: 0.02rem solid #d5d5d5;
    border-bottom: 0.02rem solid #d5d5d5;
  }
  .van-stepper__input {
    font-size: @fz28;
    color: #484848;
  }
}
</style>
<style lang="less" scoped>
.fill-after-sale-info {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 0.9rem;
  background-color: #f8f8f8;
  .auto;
  z-index: 999;
  .info-wrapper {
    h3 {
      font-size: 0.28rem;
      font-weight: 550;
    }
  }
}
.product-num-handle {
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.45rem;
  font-size: 0.28rem;
  color: #404040;
  font-weight: 550;
  background-color: #fff;
}
.after-why {
  background-color: #fff;
  font-size: 0.28rem;
  padding: 0 0.45rem;
  margin: 0.2rem 0;
  .after-why-desc {
    height: 0.88rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #404040;
    .recose {
      color: #9b9b9b;
      display: flex;
      align-items: center;
      em {
        padding-right: 0.22rem;
      }
      img {
        width: 0.18rem;
        height: 0.32rem;
        transform: rotate(180deg);
      }
    }
  }
}
.problem-desc {
  background-color: #fff;
  padding: 0.3rem 0.45rem 0.27rem;
  textarea {
    font-family: "PingFang SC Regular";
    font-size: @fz28;
    color: @base;
    width: 6rem;
    height: 2.7rem;
    padding: 0.3rem;
    border: 0.5px solid #808080;
    border-radius: 0.04rem;
    margin: 0.24rem 0;
    background-color: #fafafa;
    vertical-align: top;
  }
  .upload-img {
    img {
      width: 1rem;
      height: 1rem;
      border: 0.5px solid #9e9e9e;
      // .hairline-surround(@color: #9e9e9e, @radius: 0);
      box-sizing: border-box;
    }
  }
}
.contact-way {
  margin-top: 0.2rem;
  padding: 0.27rem 0.45rem 0.2rem;
  background-color: #fff;
  .user-name,
  .user-phone {
    height: 0.8rem;
    margin-top: 0.18rem;
    input {
      width: 100%;
      height: 100%;
      vertical-align: top;
      border: 0.5px solid #c5c5c5;
      box-sizing: border-box;
      // .hairline-surround(@color: #c5c5c5, @radius: 0.08rem);
      padding-left: 0.3rem;
      color: #404040;
      font-size: 0.26rem;
      border-radius: 0.08rem;
    }
    input::-webkit-input-placeholder {
      color: #c5c5c5;
    }
    input:focus {
      border-color: #ff9600;
    }
  }
}
.user-address-details {
  padding: 0rem 0.45rem 0.35rem;
  font-size: 0.26rem;
  background-color: #fff;
  .user-address-info {
    margin-top: 0;
  }
}
.submit-after-sale-btn {
  text-align: center;
  .submit-after-sale {
    width: 6.7rem;
    height: 0.88rem;
    margin: 0.27rem auto 0.77rem;
    background-color: #ff3824;
    font-size: 0.28rem;
    font-weight: 660;
    color: #ffffff;
    border-radius: 30px;
  }
}
.contact-service {
  padding: 0.16rem 0.45rem;
  background-color: #fff;
  color: #404040;
  margin-bottom: 0.78rem;
  h3 {
    position: relative;
    font-size: 0.28rem;
    font-weight: 550;
    padding-bottom: 0.2rem;
  }
  h3::after {
    position: absolute;
    content: "";
    width: 0.06rem;
    height: 0.25rem;
    top: 50%;
    transform: translateY(-50%);
    left: -0.25rem;
    background-color: #ff9600;
  }
  p {
    font-size: 0.24rem;
    line-height: 1.6;
  }
}
// 底部弹窗
.return-reason-mask {
  width: 100%;
  .return-reason {
    position: relative;
    width: 100%;
    height: 6.94rem;
    background-color: #fff;
    .title {
      padding: 0 0.34rem;
      height: 0.76rem;
      .flex-between;
      border-bottom: 0.5px solid #d5d5d5;
      h2 {
        font-size: @fz28;
        font-weight: bold;
      }
    }
    .return-reason-list {
      padding: 0.43rem 0;
    }
    .radio-item {
      width: 6.1rem;
      padding: 0 0.4rem;
      height: 0.68rem;
      margin: 0 auto 0.23rem;
      font-size: @fz24;
      color: @base;
      // border: 0.5px solid #e3e3e3;
      // border-radius: 30px;
      .hairline-surround(@color: #e3e3e3);
      .flex-between;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .close {
      width: 0.76rem;
      height: 0.76rem;
      background: url("../../assets/img/popup-close.png") right no-repeat;
      background-size: 0.24rem 0.24rem;
    }
    .close-popup {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 0.88rem;
      background-color: #ff3824;
      color: #fff;
      font-size: 0.28rem;
    }
  }
}
</style>
